module.exports = __webpack_public_path__ + "static/media/logo--fr.2ac22fc3.svg";